import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import * as React from "react";
import { filterDataProps } from "../../utils/FilterDataProps.js";
import { st, classes } from "./CoreInput.st.css";
class CoreInput extends React.Component {
  static displayName = "CoreInput";
  static defaultProps = {
    type: "text",
    onFocus: () => null,
    onBlur: () => null,
    onChange: () => null
  };
  state = {
    focus: false
  };
  input;
  _extractRef = (ref) => {
    const { inputRef } = this.props;
    this.input = ref;
    if (inputRef) {
      inputRef(ref);
    }
  };
  render() {
    const { focus } = this.state;
    const {
      error,
      disabled,
      prefix,
      suffix,
      style: inlineStyle,
      id
    } = this.props;
    const {
      error: errorProp,
      style: styleProp,
      prefix: prefixProps,
      suffix: suffixProp,
      inputClassName,
      className,
      inputRef,
      ...allOtherProps
    } = this.props;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: st(
          classes.root,
          { disabled, error: !!error && !disabled, focus },
          className
        ),
        style: inlineStyle,
        ...filterDataProps(this.props),
        children: [
          prefix,
          /* @__PURE__ */ jsx(
            "input",
            {
              id,
              ...allOtherProps,
              ref: this._extractRef,
              className: classNames(classes.nativeInput, inputClassName),
              onBlur: this.handleBlur,
              onFocus: this.handleFocus
            }
          ),
          suffix
        ]
      }
    );
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  select() {
    this.input.select();
  }
  getSelectionStart() {
    return this.input.selectionStart;
  }
  getSelectionEnd() {
    return this.input.selectionEnd;
  }
  setSelectionRange(start, end) {
    this.input.setSelectionRange(start, end);
  }
  handleFocus = (event) => {
    this.setState({ focus: true });
    this.props.onFocus(event);
  };
  handleBlur = (event) => {
    this.setState({ focus: false });
    this.props.onBlur(event);
  };
}
export {
  CoreInput
};
//# sourceMappingURL=CoreInput.js.map
